import { ifyouApi, ADMIN } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const advertisementApis = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/ad-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(
            error.response.status,
            error.response.data,
            error.response.koMessage,
          );
        }
      }),
  update: (inputData) =>
    ifyouApi
      .post(`${ADMIN}/ad-update`, {
        loading_is_active: inputData.loading_is_active,
        loading_interstitial: inputData.loading_interstitial,
        loading_rewarded: inputData.loading_rewarded,
        banner_is_active: inputData.banner_is_active,
        play_is_active: inputData.play_is_active,
        play_line: inputData.play_line,
        play_percent: inputData.play_percent,
        play_interstitial: inputData.play_interstitial,
        play_rewarded: inputData.play_rewarded,
        selection_is_active: inputData.selection_is_active,
        selection_interstitial: inputData.selection_interstitial,
        selection_rewarded: inputData.selection_rewarded,
        reward_is_active: inputData.reward_is_active,
        reward_interstitial: inputData.reward_interstitial,
        reward_rewarded: inputData.reward_rewarded,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(
            error.response.status,
            error.response.data,
            error.response.koMessage,
          );
        }
      }),
};

/// 광고 수정
export const advertisementUpdate = async (inputData, toggle) => {
  try {
    const response = await ifyouApi.post(`${ADMIN}/ad-update`, {
      loading_is_active: toggle.loading_is_active,
      loading_interstitial: inputData.loading_interstitial,
      loading_rewarded: inputData.loading_rewarded,
      banner_is_active: toggle.banner_is_active,
      play_is_active: toggle.play_is_active,
      play_line: inputData.play_line,
      play_percent: inputData.play_percent,
      play_interstitial: inputData.play_interstitial,
      play_rewarded: inputData.play_rewarded,
      selection_is_active: toggle.selection_is_active,
      selection_interstitial: inputData.selection_interstitial,
      selection_rewarded: inputData.selection_rewarded,
      reward_is_active: toggle.reward_is_active,
      reward_interstitial: inputData.reward_interstitial,
      reward_rewarded: inputData.reward_rewarded,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(
        error.response.status,
        error.response.data,
        error.response.koMessage,
      );
    }
  }
};
